import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { obterAvaliacaoSimulacao, salvarAvaliacaoSimulacao } from "../services/api";

// 📝 "COMO FOI O TESTE?" (23/10/2026). Formulário próprio da simulação de entrevista, pelo link do e-mail (?t=token,
// sem login). Recrutador e colega têm perguntas diferentes; uma resposta por pessoa, editável por 7 dias.
// O Nelson recebe cada resposta na hora (SimulacaoEndpoints) — é o termômetro do piloto.
const PERGUNTAS = {
  recrutador: {
    notas: [["notaAgendamento", "Agendamento"], ["notaConvite", "Convite e lembrete"], ["notaSala", "Sala de vídeo"], ["notaFeedbackIa", "Feedback da IA"]],
  },
  colega: {
    notas: [["notaEntrar", "Entrar na sala"], ["notaAudioVideo", "Áudio e vídeo"], ["notaFeedbackRecebido", "Feedback que você recebeu (foi útil?)"]],
  },
};

function Notas({ valor, onChange }) {
  return (
    <span className="inline-flex gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(valor === n ? null : n)} aria-label={`${n} de 5`}
          className={`text-2xl leading-none ${valor && n <= valor ? "text-accent" : "text-gray-300 hover:text-gray-400"}`}>★</button>
      ))}
    </span>
  );
}

function Opcoes({ valor, onChange, opcoes }) {
  return (
    <div className="flex flex-wrap gap-2 mt-1">
      {opcoes.map(([k, t]) => (
        <button key={k} type="button" onClick={() => onChange(valor === k ? null : k)}
          className={`rounded-lg border px-3 py-1.5 text-sm font-semibold ${valor === k ? "bg-primary text-white border-primary" : "bg-white border-gray-300 hover:bg-gray-50"}`}>{t}</button>
      ))}
    </div>
  );
}

function CampoTexto({ rotulo, valor, onChange, max = 2000, linhas = 3 }) {
  return (
    <label className="block mt-4">
      <span className="font-semibold text-text">{rotulo}</span>
      <textarea value={valor || ""} onChange={(e) => onChange(e.target.value)} maxLength={max} rows={linhas}
        className="mt-1 w-full rounded-xl border border-gray-300 px-3 py-2 text-sm" />
      <span className="block text-right text-[11px] text-gray-400">{(valor || "").length}/{max}</span>
    </label>
  );
}

export default function SimulacaoAvaliarPage() {
  const [params] = useSearchParams();
  const token = params.get("t") || "";
  const [info, setInfo] = useState(null);
  const [r, setR] = useState({});
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState("");
  const [enviando, setEnviando] = useState(false);
  useEffect(() => {
    document.title = "Como foi o teste? · eaiRH";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
  useEffect(() => {
    if (!token) { setErro("Link incompleto. Abra pelo botão do e-mail."); return; }
    obterAvaliacaoSimulacao(token).then((d) => { setInfo(d); setR(d.respostas || {}); }).catch((e) => setErro(e.message));
  }, [token]);
  const muda = (k) => (v) => setR((x) => ({ ...x, [k]: v }));
  const enviar = async () => {
    setErro(""); setOk(""); setEnviando(true);
    try {
      const res = await salvarAvaliacaoSimulacao(token, r);
      setOk(`Obrigado! Recebemos a sua resposta.${res?.editarAte ? ` Dá para voltar por este mesmo link e editar até ${new Date(res.editarAte).toLocaleDateString("pt-BR")}.` : ""}`);
      setInfo((i) => ({ ...i, respondida: true }));
    } catch (e) { setErro(e.message); } finally { setEnviando(false); }
  };
  const recrutador = info?.papel === "recrutador";
  const perguntas = info ? PERGUNTAS[recrutador ? "recrutador" : "colega"] : null;
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-8">
        <p className="text-xs font-bold tracking-widest text-accent uppercase">Piloto · 2 minutos</p>
        <h1 className="text-3xl font-extrabold text-text mt-1">📝 Como foi o teste?</h1>
        {info && (
          <p className="text-gray-700 mt-2">
            Simulação de entrevista {recrutador ? `com ${info.colega}` : `com ${info.empresa || "a empresa"}`} em{" "}
            {new Date(info.inicio).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}.
            A sua opinião decide o que a gente melhora primeiro.
          </p>
        )}
        {erro && <p className="mt-4 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {ok && <p className="mt-4 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">{ok}</p>}
        {info && !info.podeEditar && (
          <p className="mt-4 rounded-xl bg-slate-50 border px-3 py-2 text-sm">{info.respondida ? "O prazo para editar (7 dias) terminou. Obrigado pela resposta!" : "O prazo para responder terminou."}</p>
        )}
        {info && info.podeEditar && (
          <section className="bg-white rounded-2xl shadow-sm p-5 mt-6 text-sm">
            {info.respondida && !ok && <p className="mb-3 text-xs text-gray-500">Você já respondeu. Pode ajustar e enviar de novo até {new Date(info.editarAte).toLocaleDateString("pt-BR")}.</p>}
            <p className="font-semibold text-text">De 1 a 5, como foi cada parte? <span className="font-normal text-gray-500">(deixe em branco o que não usou)</span></p>
            <div className="mt-2 divide-y">
              {perguntas.notas.map(([k, t]) => (
                <div key={k} className="flex flex-wrap items-center justify-between gap-2 py-2"><span>{t}</span><Notas valor={r[k] || null} onChange={muda(k)} /></div>
              ))}
            </div>
            <CampoTexto rotulo="O que travou?" valor={r.oQueTravou} onChange={muda("oQueTravou")} />
            {recrutador ? (<>
              <CampoTexto rotulo="O que faltou?" valor={r.oQueFaltou} onChange={muda("oQueFaltou")} />
              <div className="mt-4">
                <span className="font-semibold text-text">Usaria com candidatos de verdade?</span>
                <Opcoes valor={r.usariaComCandidatos} onChange={muda("usariaComCandidatos")} opcoes={[["sim", "Sim"], ["talvez", "Talvez"], ["nao", "Não"]]} />
              </div>
              <CampoTexto rotulo="Por quê?" valor={r.porQue} onChange={muda("porQue")} linhas={2} />
            </>) : (
              <div className="mt-4">
                <span className="font-semibold text-text">O feedback te ajudou?</span>
                <Opcoes valor={r.feedbackAjudou} onChange={muda("feedbackAjudou")} opcoes={[["sim", "Sim"], ["mais_ou_menos", "Mais ou menos"], ["nao", "Não"]]} />
              </div>
            )}
            <CampoTexto rotulo="Comentários / sugestões" valor={r.comentarios} onChange={muda("comentarios")} linhas={4} />
            <div className="flex justify-end mt-4">
              <button onClick={enviar} disabled={enviando}
                className="rounded-lg bg-accent hover:opacity-90 disabled:opacity-40 text-white font-semibold px-5 py-2">{enviando ? "Enviando…" : info.respondida ? "Salvar alterações" : "Enviar"}</button>
            </div>
            <p className="text-[11px] text-gray-400 mt-3">As respostas vão só para a equipe do eaiRH, para melhorar o piloto.</p>
          </section>
        )}
      </main>
    </div>
  );
}
